import React from "react";

import TextInput, { InputProps } from "../TextInput/TextInput";

const SearchInput = (props: InputProps) => <TextInput {...props} type="search" icon="search" />;

export default SearchInput;
